import etribeMark from '../../assets/icons/etribe-mark.svg';

const COLS = [
  {
    title: 'Empresa',
    items: [
      ['#nosotros', 'Sobre nosotros'],
      ['#equipo', 'Cultura'],
      ['https://recruiting.etribe.consulting/', 'Carreras'],
      ['#casos', 'Casos de éxito'],
    ],
  },
  {
    title: 'Servicios',
    items: [
      ['#servicios', 'Digital Consulting'],
      ['#servicios', 'CRM & Growth'],
      ['#servicios', 'Data, Analytics & AI'],
      ['#servicios', 'Tech Architecture'],
      ['#arkeflow', '#ARKEFLOW'],
    ],
  },
  {
    title: 'Recursos',
    items: [
      ['#partners', 'Partners & certs'],
      ['#modalidades', 'Modalidades'],
      ['#industrias', 'Industrias'],
    ],
  },
];

const ICONS = {
  mail: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  ),
  phone: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 4h4l2 5-3 2a12 12 0 006 6l2-3 5 2v4a2 2 0 01-2 2C9 22 2 15 2 6a2 2 0 012-2z" />
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M4 4h4v4H4zM4 10h4v10H4zM10 10h4v2c.5-1 2-2.5 4-2.5 3 0 4 2 4 5v5.5h-4v-5c0-1.5-.5-2.5-2-2.5s-2 1-2 2.5v5h-4z" />
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r=".8" fill="currentColor" />
    </svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 12a8 8 0 01-12 6.9L4 20l1.2-3.8A8 8 0 1120 12zm-8-6a6 6 0 00-5.2 9l-.7 2.2 2.3-.6A6 6 0 1012 6zm3.4 7.4c-.2-.1-1.2-.6-1.4-.7-.2-.1-.3-.1-.5.1l-.7.8c-.1.2-.3.2-.5.1a4.9 4.9 0 01-2.4-2.1c-.2-.3 0-.4.1-.6l.4-.5c.1-.1.1-.3 0-.4l-.6-1.5c-.2-.4-.3-.3-.5-.3h-.4c-.2 0-.4 0-.6.3-.2.3-.8.8-.8 1.9s.8 2.2.9 2.4c.1.2 1.7 2.5 4 3.4 1.5.5 1.9.5 2.6.4.4-.1 1.2-.5 1.4-1 .2-.5.2-.9.1-1z" />
    </svg>
  ),
};

const CONTACTS = [
  { href: 'mailto:contacto@etribe.mx',                                  label: 'contacto@etribe.mx', icon: ICONS.mail },
  { href: 'tel:+525579477925',                                          label: '+52 55 7947 7925',   icon: ICONS.phone },
  { href: 'https://www.linkedin.com/company/etribe-mx/',                label: 'LinkedIn',           icon: ICONS.linkedin },
  { href: 'https://www.instagram.com/etribe_mx',                        label: 'Instagram',          icon: ICONS.instagram },
  { href: 'https://api.whatsapp.com/send/?phone=5215579477925',         label: 'WhatsApp',           icon: ICONS.whatsapp },
];

export default function Footer() {
  return (
    <footer className="bg-etribe-blue-dark text-white/70 pt-24 pb-8">
      <div className="container-etribe">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr] pb-14 border-b border-white/10">
          <div>
            <a href="#top" aria-label="eTribe — Inicio" className="inline-flex items-center mb-5">
              <img
                src={etribeMark}
                alt="eTribe"
                className="h-10 w-auto select-none"
                draggable={false}
              />
            </a>
            <p className="text-sm leading-snug max-w-[28ch] text-justify hyphens-auto">
              Consultora mexicana de innovación tecnológica especializada en Data, Analytics e IA.
            </p>
          </div>

          {COLS.map(({ title, items }) => (
            <div key={title}>
              <h2 className="text-white text-[13px] tracking-[0.12em] uppercase mb-5 font-heading">{title}</h2>
              <ul className="flex flex-col gap-3">
                {items.map(([href, label]) => {
                  const isExternal = href.startsWith('http');
                  return (
                    <li key={label}>
                      <a
                        href={href}
                        {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
                        className="text-sm text-white/65 hover:text-etribe-yellow transition-colors"
                      >
                        {label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}

          <div>
            <h5 className="text-white text-[13px] tracking-[0.12em] uppercase mb-5 font-heading">Contacto</h5>
            <ul className="flex flex-col gap-3">
              {CONTACTS.map(({ href, label, icon }) => (
                <li key={label}>
                  <a href={href} className="inline-flex items-center gap-2.5 text-sm text-white/65 hover:text-etribe-yellow transition-colors group">
                    <span className="w-3.5 h-3.5 flex-shrink-0 text-etribe-yellow opacity-85 group-hover:opacity-100 group-hover:-translate-y-0.5 transition-all">
                      {icon}
                    </span>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex items-center justify-center pt-8">
          <p className="text-xs text-white/50 text-center">© {new Date().getFullYear()} eTribe S.A. de C.V. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
